import { render, staticRenderFns } from "./comp9.vue?vue&type=template&id=dead1632&scoped=true"
import script from "./comp9.vue?vue&type=script&lang=ts"
export * from "./comp9.vue?vue&type=script&lang=ts"
import style0 from "./comp9.vue?vue&type=style&index=0&id=dead1632&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dead1632",
  null
  
)

export default component.exports